export function intercom(...args: any) {
  if (process.env.REACT_APP_INTERCOM_ACTIVATED === 'true') {
    return (window as any).Intercom(...args)
  }
}
